import fieldsHelper from '../utils/fieldsHelper';
import definitions from './definitions';
import helpers from './helpers';
/**
 * @param {string} formula
 * @param {import('../logic/types').EcrionFormField} field
 * @param {import("../logic/types").EcrionFormState} state
 * @returns {string}
 */

var calculate = function calculate(formula, field, state) {
  if (!formula) return;
  return formula.replace(/{[^}]+}?}/g, function (expression) {
    return calculateExpression(expression, field, state);
  });
};
/**
 * @param {string} expression
 * @param {import('../logic/types').EcrionFormField} field
 * @param {import("../logic/types").EcrionFormState} state
 * @returns {any}
 */


var calculateExpression = function calculateExpression(expression, field, state) {
  if (!expression) return expression;
  if (typeof expression !== 'string') return expression;
  if (expression.startsWith('{{FORMULA')) return calculateFormula(expression, field, state);
  if (expression.startsWith('{{FIELD')) return getFieldValue(expression, field, state);
  return getContextValue(expression, state);
};
/**
 * @param {import('./types').EcrionFormFormula} formula
 * @param {import("../logic/types").EcrionFormField} field
 * @param {import("../logic/types").EcrionFormState} state
 * @returns {any}
 */


var calculateFormulaToken = function calculateFormulaToken(formula, field, state) {
  if (!formula || !formula.id) return '';
  if (!formula.id) return formula.value;
  if (formula.id.toLowerCase() === 'formula') return evaluateFormula(formula, state);
  if (formula.id.toLowerCase() === 'field') return getFieldValue(formula.value, field, state);
  if (formula.id.toLowerCase() === 'context') return getContextValue(formula.value, state);
  return formula.value;
};
/**
 * @param {string} formulaId
 * @param {import("../logic/types").EcrionFormState} field
 * @param {import("../logic/types").EcrionFormState} state
 * @returns {any}
 */


var calculateFormula = function calculateFormula(formulaId, field, state) {
  var formula = state.formulas[formulaId];
  if (!formula) return; // formula is missing

  return evaluateFormula(formula, field, state);
};
/**
 * @param {import('./types').EcrionFormFormula} formula
 * @param {import("../logic/types").EcrionFormField} field
 * @param {import("../logic/types").EcrionFormState} state
 * @returns {any}
 */


var evaluateFormula = function evaluateFormula(formula, field, state) {
  var definition = definitions.getDefinition(formula.id);
  if (!definition) return calculateFormulaToken(formula, field, state);

  switch (definition.type) {
    case 'formula':
      var params = formula.value.map(function (f) {
        return evaluateFormula(f, field, state);
      });
      return definition.callback.apply(null, params);

    case 'text':
    default:
      return formula.value;
  }
};
/**
 * @param {string} fieldToken
 * @param {import("../logic/types").EcrionFormField} field
 * @param {import("../logic/types").EcrionFormState} state
 * @returns {any}
 */


var getFieldValue = function getFieldValue(fieldToken, field, state) {
  if (!state) return;
  var fieldId = helpers.extractFieldId(fieldToken); // we need to find a field that is in the same repeating context as the field
  // for wich value we are calculating

  var candidates = Object.keys(state.fields).map(function (id) {
    return state.fields[id];
  });
  var candidate = candidates.find(function (f) {
    return f.originalId === fieldId && fieldsHelper.hasCommonRepeatingContext(state, field, f);
  }); // if we found another field in same context as field, we use it

  fieldId = candidate ? candidate.id : fieldId;
  return state.data && state.data[fieldId] || '';
};
/**
 * @param {string} value
 * @param {import("../logic/types").EcrionFormState} state
 * @returns {any}
 */


var getContextValue = function getContextValue(value, state) {
  if (!state.context || !state.context.environmentVars) return;
  var contextId = helpers.extractContextId(value);
  return state.context.environmentVars[contextId] || '';
};

export default {
  calculate: calculate
};